module.exports = __webpack_public_path__ + "static/media/sf_200_gray.fdad41aa6c03c33108e6463a589462f0.png";